const LedgerRecordTypeEnum = {
  System: 1,
  Store: 2,
  Partner: 3,
  Customer: 4,
};

export default LedgerRecordTypeEnum;
